import { Blobatar } from "@blobatar/react";
import { memo } from "react";

export const TaskBlobatar = memo(function TaskBlobatar({
  className,
  name,
}: {
  className?: string;
  name: string;
}) {
  return (
    <Blobatar
      name={name}
      size={32}
      animate="always"
      aria-hidden
      data-testid="task-blobatar"
      className={className ? `size-8 shrink-0 ${className}` : "size-8 shrink-0"}
    />
  );
});
